import {
  GET_FIRST_DECISION_TREE_STEP,
  GET_NEXT_DECISION_TREE_STEP,
  GET_PREVIOUS_DECISION_TREE_STEP,
  UPDATE_CURRENT_DECISION_TREE_STEP,
} from './types';
import { createAction, getActionList } from './action-utils';

const actions = {
  updateCurrentDecisionTree: ({ nextQuestion }: { [_: string]: any }) =>
    createAction(UPDATE_CURRENT_DECISION_TREE_STEP, {
      response: {
        nextQuestion,
      },
    }),
  getNextDTQuestion: ({
    answer,
    question,
    displayName,
  }: {
    [_: string]: any;
  }) =>
    createAction(GET_NEXT_DECISION_TREE_STEP, {
      answer,
      question,
      displayName,
    }),
  getPreviousDTQuestion: () =>
    createAction(GET_PREVIOUS_DECISION_TREE_STEP, {}),
  getCurrentDTOptions: () => createAction(GET_NEXT_DECISION_TREE_STEP, {}),
  getFirstDTOptions: () => createAction(GET_FIRST_DECISION_TREE_STEP, {}),
};

export default actions;

const actionList = getActionList(actions);

export type DecisionTreeCurrentStepActionType = typeof actionList[number];
